import axios from 'axios'
import Vue from 'vue'
import _this from '../main.js';
import store from '../store/store.js'

const env = process.env.NODE_ENV
export const ip = env == 'development' ? 'http://59.110.21.199:9000' : env == 'production' ? 'http://39.107.82.135:9000' : 'https://server.anycmp.com'
export const serverCenterIp = env == 'development' ? 'http://59.110.21.199:11001' : env == 'production' ? 'http://59.110.21.199:11001' : 'https://price-api.anycmp.com'
console.log(ip)
const token = COOKIE.get('token')
export const headers ={
  'token': token
}


axios.defaults.baseURL = ip;
axios.defaults.headers=headers

/*用户中心*/
const usercenterAxios = axios.create({
  baseURL:ip + '/usercenter',
  headers:headers
})

/*系统中心*/
const sysConfigAxios = axios.create({
  baseURL:ip + '/sysconfig',
  headers: headers
})

//阿里pro
const aliproAxios = axios.create({
  baseURL:ip + '/alipro',
  headers: headers
})

//订单
const orderAxios = axios.create({
  baseURL:ip + '/order',
  headers: headers
})

//支付
const payAxios = axios.create({
  baseURL:ip + '/pay',
  headers: headers
})
//费用服务
const costsAxios = axios.create({
  baseURL:ip +'/costs',
  headers:headers
})

//工单
const workorderAxios = axios.create({
  baseURL:ip +'/workorder',
  headers:headers
})

//资源
const resourceAxios = axios.create({
  baseURL:ip +'/resource',
  headers:headers
})

//ZStack
const ZStackAxios = axios.create({
  baseURL:ip +'/zstack',
  headers:headers
})

//价格服务
const priceAxios = axios.create({
  baseURL:serverCenterIp,
  headers:headers
})



const response = function(obj) {

  obj.interceptors.request.use(config => {
    if(COOKIE.get('token')){
      config.headers.token = COOKIE.get('token')
    }else if(_this.$route.path != '/login'){
      // _this.$alert('登录失效', '错误', {
      //   confirmButtonText: '确定',
      //   type: 'warning',
      //   callback: action => {
      //     COOKIE.del('token');
      //     window.localStorage.removeItem('menu')
      //     window.localStorage.removeItem('info')
      //     _this.$router.push({ path: '/login',query:{callback:_this.$route.fullPath} });
      //   }
      // });
    }
    return config;
  }, err => {
    Message.error({ message: '请求超时!' });
    return Promise.resolve(err);
  })


  obj.interceptors.response.use(data => {
    if(data.headers.token){
      let token = data.headers.token;
      let tokenList = token.split('.');
      let time=JSON.parse(BASE64.decoder(tokenList[1])).exp
      COOKIE.set('token',token,time)
    }
    return data;
  }, err => {
    if(err.response == undefined && err.message=='Network Error'){
        _this.$message.error('网络异常,无法连接到网络');
    }else{
        switch (err.response.status) {
      case 401:
        if (err.response.data.code == "needLogin") {
          _this.$alert('登录失效', '错误', {
            confirmButtonText: '确定',
            type: 'warning',
            callback: action => {
              COOKIE.del('token');
              window.localStorage.removeItem('menu')
              window.localStorage.removeItem('info')
              _this.$router.push({ path: '/login',query:{callback:_this.$route.fullPath} });
            }
          });
        }
        break;
      case 404:
        if (err.response.data.error == "Not Found") {
          _this.$message.error('未找到内容');
        }
        break;
      case 500:
        if (err.response.data.code == "InternalError") {
          _this.$message.error('服务器内部错误');
        }else if(err.response.data.message == "TIMEOUT"){
           _this.$message.error('请求超时');
        }else{
          _this.$message.error('服务器错误');
        }
        break;
    }
    }

    return Promise.resolve(err);
  })
}


response(usercenterAxios)
response(sysConfigAxios)
response(axios)
response(aliproAxios)
response(orderAxios)
response(payAxios)
response(costsAxios)
response(workorderAxios)
response(resourceAxios)
response(ZStackAxios)
response(priceAxios)


Vue.prototype.usercenterAxios = usercenterAxios;
Vue.prototype.sysconfigAxios = sysConfigAxios;
Vue.prototype.axios = axios;
Vue.prototype.aliproAxios = aliproAxios;
Vue.prototype.orderAxios = orderAxios;
Vue.prototype.payAxios = payAxios;
Vue.prototype.costsAxios=costsAxios
Vue.prototype.workorderAxios=workorderAxios
Vue.prototype.resourceAxios=resourceAxios
Vue.prototype.ZStackAxios=ZStackAxios
Vue.prototype.priceAxios=priceAxios



// WEBPACK FOOTER //
// ./src/config/axiosConfig.js